import { useRootStore } from '../index';
import { action, observable } from 'mobx';
import { ArticleAssetTypeEnum } from '../../api';
import { ImageTabs } from 'pages/Article/components/GoogleCampaignArticle/components/GoogleAssetsBuilder/constants';

export type GoogleAssetImage = { url: string; blob: Blob; type: ArticleAssetTypeEnum };

export class GoogleAssetsImagesStore {
  @observable activeTab: ImageTabs = ImageTabs.MARKETER;
  @action setActiveTab = (tab: ImageTabs) => (this.activeTab = tab);

  @observable images: GoogleAssetImage[] = [];
  @action setImages = (images: GoogleAssetImage[]) => (this.images = images);

  @observable openImageUploaderDialog = false;
  @action setOpenImageUploaderDialog = (value: boolean) => (this.openImageUploaderDialog = value);
}

export const useGoogleAssetsImagesStore = (): GoogleAssetsImagesStore => {
  const store = useRootStore();
  if (!store.googleAssetsImagesStore) throw new Error('Google Assets Builder store has not been initialized');
  return store.googleAssetsImagesStore;
};
